module.exports = __webpack_public_path__ + "static/img/a-2.1acc50df.png";